"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Label = _interopRequireDefault(require("./Label"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/label-has-associated-control */
// Theme
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Switch__Wrapper",
  componentId: "design-system__sc-1qqljhu-0"
})(["display:flex;height:", "px;align-items:center;box-sizing:border-box;& > label{padding:0;margin-left:0.5rem;font-size:", "px;white-space:nowrap;}"], _ref => {
  let {
    size
  } = _ref;
  return size;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size;
});

const SwitchWrapper = _styledComponents.default.div.withConfig({
  displayName: "Switch__SwitchWrapper",
  componentId: "design-system__sc-1qqljhu-1"
})(["position:relative;display:inline-block;& > input{display:none;}& > label{display:block;width:", "px;height:", "px;text-indent:-150%;clip:rect(0 0 0 0);color:transparent;user-select:none;}& > label::before,& > label::after{content:\"\";display:block;position:absolute;cursor:pointer;}& > label::before{width:100%;height:100%;background-color:#dedede;border-radius:9999em;-webkit-transition:background-color 0.25s ease;transition:background-color 0.25s ease;}& > label::after{top:0;left:0;width:", "px;height:", "px;border-radius:50%;background-color:#fff;box-shadow:0 0 2px rgba(0,0,0,0.45);-webkit-transition:left 0.25s ease;transition:left 0.25s ease;}& > input:checked + label::before{background-color:", ";}& > input:checked + label::after{left:", "px;}"], _ref3 => {
  let {
    size
  } = _ref3;
  return size * 2;
}, _ref4 => {
  let {
    size
  } = _ref4;
  return size;
}, _ref5 => {
  let {
    size
  } = _ref5;
  return size;
}, _ref6 => {
  let {
    size
  } = _ref6;
  return size;
}, _BaseTheme.default.colors.green, _ref7 => {
  let {
    size
  } = _ref7;
  return size;
});

const Switch = _ref8 => {
  let {
    id,
    label,
    onChange,
    checked,
    size
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(SwitchWrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: id,
    type: "checkbox",
    onChange: onChange,
    checked: checked
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, "Switch")), /*#__PURE__*/_react.default.createElement(_Label.default, null, label));
};

Switch.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  checked: _propTypes.default.bool,
  size: _propTypes.default.number
};
Switch.defaultProps = {
  label: undefined,
  checked: undefined,
  size: 24
};
var _default = Switch;
exports.default = _default;